import TaskDetailsElement from './TaskDetailsElement';
import {AlertSettingsProps} from '../settings/alert_alarm/types';
import {TasksDetailsResponseProps} from './types';
import {FC} from 'react';

type ProcessTasksProps = {
  tasksDetailsData: Nullable<TasksDetailsResponseProps>,
  taskAlertData: Nullable<AlertSettingsProps>
};

const ProcessTasks: FC<ProcessTasksProps> = ({
  tasksDetailsData,
  taskAlertData
}) => {
  if (!tasksDetailsData || !taskAlertData) return null;

  return (
    <>
      {tasksDetailsData.slice(0).reverse().map((taskItem, index) =>
        <TaskDetailsElement
          key={`task_id_${taskItem.id}`}
          taskItem={taskItem}
          taskAlertData={taskAlertData}
          taskNumber={tasksDetailsData.length - index}
        />
      )}
    </>
  );
};

export default ProcessTasks;
